import { MONEY_SCALE, PERCENT_SCALE, UNIT_PRICE_SCALE, add, compare, decimal, divide, isPositive, multiply, round, subtract, zero, } from '@aeris/money';
/**
 * Preço de venda a partir do custo mais uma margem (F123).
 *
 * ## Qual margem, porque existem duas
 *
 * "30% de margem" quer dizer coisas diferentes para gente diferente, e a
 * diferença não é pequena — num custo de R$ 100:
 *
 * - **markup sobre o custo**: `100 × 1,30` = **R$ 130,00**
 * - **margem sobre o preço**: `100 ÷ 0,70` = **R$ 142,86**
 *
 * Este produto usa **markup sobre o custo**, e não por gosto: a F110 já decidiu
 * assim quando escreveu a trava de margem mínima do preço de canal
 * (`requiredNetFor` = `custo × (1 + margem)`). Duas definições de margem dentro
 * do mesmo ERP produziriam uma tela dizendo que o anúncio dá 30% e outra
 * dizendo que dá 23%, sobre o mesmo produto, ambas "certas".
 *
 * A tela diz "markup sobre o custo" com todas as letras. Quem trabalha com
 * margem sobre o preço vai converter uma vez; quem descobre a diferença na
 * planilha do contador descobre tarde.
 */
/** Preço = custo × (1 + margem/100), arredondado para a escala de preço unitário. */
export const priceFromMargin = (cost, marginPercent) => round(add(cost, divide(multiply(cost, marginPercent), ONE_HUNDRED, 
// Escala alta no meio do caminho: arredondar aqui e de novo no fim
// acumularia o erro duas vezes sobre o mesmo número.
UNIT_PRICE_SCALE + PERCENT_SCALE, 'half-up')), UNIT_PRICE_SCALE, 'half-up');
/**
 * A margem que um preço representa sobre um custo — o caminho inverso.
 *
 * Devolve `null` quando o custo é zero ou negativo, e isso é o ponto: com custo
 * zero, QUALQUER preço dá margem infinita. Mostrar "∞%" ou um número gigante na
 * tela seria pior que não mostrar nada, porque parece uma informação. A tela
 * diz "sem custo cadastrado" e para de falar de margem.
 */
export const marginFromPrice = (cost, price) => {
    if (!isPositive(cost))
        return null;
    return round(divide(multiply(subtract(price, cost), ONE_HUNDRED), cost, PERCENT_SCALE + 2, 'half-up'), PERCENT_SCALE, 'half-up');
};
/**
 * O lucro em dinheiro de uma venda — `preço − custo`.
 *
 * Pode ser negativo, de propósito. Vender abaixo do custo é uma decisão
 * legítima (queima de estoque, peça encalhada), e recusá-la aqui faria a tela
 * mentir sobre uma operação que a loja tem o direito de fazer. Quem precisa
 * PROIBIR isso é a trava de margem mínima do canal (F110), onde a decisão é do
 * dono da loja e está escrita.
 */
export const profitOf = (cost, price) => round(subtract(price, cost), MONEY_SCALE, 'half-up');
/** Se o preço cobre ao menos o custo. Falso é aviso na tela, nunca recusa. */
export const coversCost = (cost, price) => compare(price, cost) >= 0;
const ONE_HUNDRED = decimal(100n, 0);
/** Zero na escala de percentual — o ponto de partida de um formulário vazio. */
export const ZERO_PERCENT = zero(PERCENT_SCALE);
//# sourceMappingURL=margin.js.map